module.exports = __webpack_public_path__ + "img/hotel-icon.6090fc80.svg";